import {Button, Heading} from '@primer/react'
import type React from 'react'

import styles from './DefinitionDangerZone.module.css'

function DangerZone({children}: {children: React.ReactNode}) {
  return (
    <div>
      <Heading as="h2" className="f3 mb-2">
        Additional options
      </Heading>
      <div className="border rounded-2">{children}</div>
    </div>
  )
}

type ActionItemProps = {
  ref?: React.Ref<HTMLButtonElement>
  title: string
  subtitle?: string
  onClick?: () => void
  variant?: 'danger' | 'default'
}

const ActionItem = ({ref, title, subtitle, onClick, variant = 'default'}: ActionItemProps) => {
  return (
    <div className={styles.actionItem}>
      <div className="d-flex tmp-p-3">
        <div className="flex-1">
          <Heading as="h3" className="f5">
            {title}
          </Heading>
          <span className="color-fg-muted text-small">{subtitle}</span>
        </div>
        <Button ref={ref} onClick={onClick} variant={variant}>
          {title}
        </Button>
      </div>
      <hr className={styles.divider} />
    </div>
  )
}
ActionItem.displayName = 'ActionItem'

export const DefinitionDangerZone = Object.assign(DangerZone, {ActionItem})
